:host {
  display: block;
}

.efficiency__table {
  max-width: 800px;
}

rt-graph + .efficiency__table {
  margin-top: 20px;
}
